import { render, staticRenderFns } from "./GameletQA.vue?vue&type=template&id=ef95db86&scoped=true"
import script from "./GameletQA.vue?vue&type=script&lang=ts"
export * from "./GameletQA.vue?vue&type=script&lang=ts"
import style0 from "./GameletQA.vue?vue&type=style&index=0&id=ef95db86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef95db86",
  null
  
)

export default component.exports